import i18n from 'i18n/config'
import { validateIIN } from 'utils/validateIIN'
import * as yup from 'yup'

export const thirdPartyPledgeFormSchema = yup.object({
  iin: yup
    .string()
    .min(12, i18n.t('create-lead-schema.iin-min').toString())
    .max(12)
    .test('checkIin', i18n.t('create-lead-schema.iin-validation').toString(), validateIIN)
    .required(),
  phone: yup.string().min(11, i18n.t('create-lead-schema.phone-min').toString()).max(11).required()
})

export type ThirdPartyPledgeFormValues = yup.InferType<typeof thirdPartyPledgeFormSchema>
